<template>
  <div class="container">
    <div v-if="showSpinner" class="spinner-container">
      <spinner-el class="spinner" />
    </div>

    <template v-else>
      <head-title class="head-title">Alerts</head-title>
      <router-link
        :to="`/add-alert/${leaderTicker && leaderTicker.id}`"
        class="create-alert-link"
        :class="{'create-alert-link_disabled': !leaderTicker}"
      >
        <button-el red class="create-alert-btn create-alert-btn_top" :disabled="!leaderTicker">CREATE ALERT</button-el>
      </router-link>

      <div class="alerts-wrapper">

        <vue-accordion>
            <!-- TODO fix accordion jumping when user clicks `show all XXX alerts` and after that opens another group with a lot of alerts-->
            <!-- TODO remove v-if when BE bug will be fixed-->
            <vue-accordion-item
              v-for="currency in accordionItems"
              v-if="currency.alerts.length"
              :key="currency.tickerId"
              @onClickAccordionItem="hideAlertsLists(currency.tickerId)"
              :openFirstGroup="openFirstAccordionItem"
            >
              <div slot="title" class="alert__title">
                <router-link :to="`/currency/${currency.tickerId}`" class="alert-top-link">
                  <div class="alert-top">
                    <div class="alert__icon">
                      <currency-icon :currencyId="currency.tickerId" class="icon"/>
                    </div>
                    <div class="alert__name">{{currency.tickerName}} ({{currency.symbol}})</div>
                  </div>
                </router-link>
                <router-link class="alert__create-btn alert__create-btn_desktop" :to="`/add-alert/${currency.tickerId}`">
                  <button-el red class="alert-top__create-alert">CREATE ALERT</button-el>
                </router-link>
              </div>

              <div class="content-wrapper" slot="content">
                <table-el animated class="table">
                  <tr slot="thead" class="table__tr table__trh">
                    <th class="table__th table__th_parameter">parameter</th>
                    <th class="table__th table__th_start">start value</th>
                    <th class="table__th table__th_value">alert value</th>
                    <th class="table__th table__th_live">live</th>
                    <th class="table__th table__th_repeat">repeat</th>
                    <th class="table__th table__th_channels">channels</th>
                    <th class="table__th table__th_created">created</th>
                    <th class="table__th table__th_status">status</th>
                    <th class="table__th table__th_options"></th>
                  </tr>
                  <tr
                    slot="tbody"
                    class="table__tr table__trd"
                    v-for="alert in getShowedAlerts(currency.alerts, currency.tickerId)"
                    :key="alert.id"
                    :class="{'table__tr_just-created': alert.flagNew, 'table__tr_hide-new-label': !showNewFlag, 'table__tr_archived': alertIsArchived(alert)}"
                    @mouseover="markAsRead(alert)
                  ">
                    <td class="table__td table__td_parameter">
                      <div class="table__td_label-new">NEW</div>
                      {{alert.valueType | beautifyValueType}}
                      <icon-tendency-arrow
                        v-if="alert.directionOfChange"
                        :up="directionOfChangeIsUp(alert.directionOfChange)"
                        class="icon-tendency"
                        :gray="alert | alertIsArchivedFilter"
                      />
                      <div class="hover-link" v-if="alertIsArchived(alert)" @click="repeatAlert(alert.id)">
                        Repeat
                      </div>
                      <div class="hover-link" v-else @click="archiveAlert(alert.id)">
                        Archieve
                      </div>
                    </td>
                    <td class="table__td table__td_start">
                      {{alert.baseValue | formatMoney(alert.currencyCode)}}
                      <div class="hover-link" v-if="alertIsArchived(alert)" @click="deleteAlert(alert.id)">
                        Delete
                      </div>
                      <div class="hover-link" v-else @click="editAlert(alert.id)">
                        Edit
                      </div>
                    </td>
                    <td class="table__td table__td_value">{{alert.targetValue | beautifyTargetDeltaValueWithUnits(alert.alertType, alert.currencyCode)}}</td>
                    <td class="table__td table__td_live">
                      <div class="td-inline-flex-wrapper">
                        <circle-bar class="circle-bar" :percentageToCompletion="alert | getPercent"/>
                        {{alert.currentValue | formatMoney(alert.currencyCode)}}
                      </div>
                    </td>
                    <td class="table__td table__td_repeat">
                      {{beautifyRepeatValue(alert.frequency)}}
                    </td>
                    <td class="table__td table__td_channels">
                      {{alert | generateChannelsList}}
                    </td>
                    <td class="table__td table__td_created">{{alert.createdAt | formatDate(shortMonthDateFormat)}}</td>
                    <td class="table__td table__td_status">
                      {{alert.status}}
                    </td>
                    <td class="table__td table__td_options">
                      <button-menu
                        class="options"
                        :archived="alert | alertIsArchivedFilter"
                        @onClickArchive="archiveAlert(alert.id)"
                        @onClickDelete="deleteAlert(alert.id)"
                        @onClickRepeat="repeatAlert(alert.id)"
                        @onClickEdit="editAlert(alert.id)"
                        :class="{'button-menu_disabled': requestAlertInProgress}"
                      >
                        <icon-base class="icon-gear" slot="icon" red>
                          <icon-gear/>
                        </icon-base>
                      </button-menu>
                    </td>
                    <div class="hover"></div>
                    <div class="unexpected-click-preventer"></div>
                  </tr>
                </table-el>
              </div>
              <div
                slot="content"
                v-if="alertsCountMoreThanAvailable(currency.alerts.length, currency.tickerId)"
                class="show-alerts-wrapper"
              >
                <button
                  class="show-alerts"
                  @click="expandAlertsList(currency.tickerId)">
                  ALL {{currency.tickerName}} ALERTS ({{currency.alerts.length}})
                </button>
              </div>
              <div slot="content" class="alert__create-btn alert__create-btn_mobile">
                <router-link :to="`/add-alert/${currency.tickerId}`">
                  <button-el red>CREATE ALERT</button-el>
                </router-link>
              </div>
            </vue-accordion-item>

        </vue-accordion>

      </div>
      <div v-if="showAllAlertsLink" class="view-all-currencies-wrapper">
        <router-link class="view-all-currencies" to="/alert-management">VIEW ALL CURRENCIES</router-link>
      </div>

    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { formatMoney, formatDate, beautifyTargetDeltaValueWithUnits, beautifyValueType } from 'src/utils/helpers';
import { shortMonthDateFormat } from 'src/utils/config';
import { IconGear, IconTendencyArrow } from 'Icons';
import ButtonMenu from 'Uikit/ButtonMenu';
import VueAccordion from 'Uikit/Accordion/VueAccordion';
import VueAccordionItem from 'Uikit/Accordion/VueAccordionItem';
import AlertsChannels from 'src/models/AlertsChannels';
import AlertsRepeats from 'src/models/AlertsRepeats';
import CircleBar from './CircleBar';

// eslint-disable
export const maxCountRowsVisibleInAlertManagmentGroup = 4;
export const maxCountAlertGroupedByTickersInSmallVersion = 4;
// eslint-enable

function alertIsArchived({ status }) {
  return status === 'archived';
}

export default {
  data: () => ({
    AlertsRepeats,
    AlertsChannels,
    requestAlertInProgress: false,
    // object with { key === tickerId:number }, { val === showAllAlerts:bool }
    showingAllStatesForAlerts: {},
    showSpinner: true,
    showNewFlag: true,
  }),
  props: {
    fullVersion: Boolean,
  },
  components: {
    IconGear,
    IconTendencyArrow,
    ButtonMenu,
    CircleBar,
    VueAccordion,
    VueAccordionItem,
  },
  computed: {
    shortMonthDateFormat: () => shortMonthDateFormat,
    ...mapState('alerts', [
      'alertGroupedByTickers',
    ]),
    ...mapGetters('userData', ['currencyCode']),
    ...mapState('tickers', [
      'leaderTicker',
    ]),
    accordionItems() {
      if (!this.fullVersion) {
        // eslint-disable-next-line
        return this.alertGroupedByTickers.slice(0, maxCountAlertGroupedByTickersInSmallVersion);
      }
      return this.alertGroupedByTickers;
    },
    showAllAlertsLink() {
      const currencyAlertsCount = this.alertGroupedByTickers.length;
      // eslint-disable-next-line
      return !this.fullVersion && currencyAlertsCount >= maxCountRowsVisibleInAlertManagmentGroup;
    },
    openFirstAccordionItem() {
      return this.alertGroupedByTickers.some(val => val.alerts[0].flagNew);
    },
  },
  methods: {
    ...mapActions('alerts', [
      'getAlertsGroupedByTickers',
    ]),
    ...mapActions('tickers', [
      'getLeaderTicker',
    ]),
    hideAlertsLists(tickerId) {
      // for reactivity
      this.$set(this.showingAllStatesForAlerts, tickerId, false);
    },
    expandAlertsList(tickerId) {
      // for reactivity
      this.$set(this.showingAllStatesForAlerts, tickerId, true);
    },
    alertsCountMoreThanAvailable(rowsCount, tickerId) {
      const rowsCountMoreThanWeCanShow = rowsCount > maxCountRowsVisibleInAlertManagmentGroup;
      return rowsCountMoreThanWeCanShow && !this.showingAllStatesForAlerts[tickerId];
    },
    beautifyRepeatValue(val) {
      if (val === 'one_time_event') {
        return AlertsRepeats.one_time_event;
      }
      if (val === 'persistent') {
        return AlertsRepeats.persistent;
      }
      return '';
    },
    directionOfChangeIsUp(direction) {
      return direction === 'up';
    },
    deleteAlert(id) {
      this.requestAlertInProgress = true;
      if (confirm('Are you sure?')) { // eslint-disable-line
        this.$apiService.deleteAlert(id).then(() => {
          this.getAlertsGroupedByTickers();
        }).finally(() => {
          this.requestAlertInProgress = false;
        });
      }
    },
    repeatAlert(id) {
      this.$router.push(`/repeat-alert/${id}`);
    },
    editAlert(id) {
      this.$router.push(`/edit-alert/${id}`);
    },
    archiveAlert(id) {
      if (confirm('Are you sure?')) { // eslint-disable-line
        this.$apiService.archiveAlert(id).then(() => {
          this.getAlertsGroupedByTickers();
        }).finally(() => {
          this.requestAlertInProgress = false;
        });
      }
    },
    getShowedAlerts(currencyAlerts, tickerId) {
      // eslint-disable-next-line
      if (currencyAlerts.length > maxCountRowsVisibleInAlertManagmentGroup && !this.showingAllStatesForAlerts[tickerId]) {
        return currencyAlerts.slice(0, maxCountRowsVisibleInAlertManagmentGroup);
      }
      return currencyAlerts;
    },
    markAsRead(alert) {
      if (alert.flagNew) {
        this.showNewFlag = false;
      }
    },
    alertIsArchived,
  },
  filters: {
    formatMoney,
    formatDate,
    beautifyValueType,
    beautifyTargetDeltaValueWithUnits,
    alertIsArchivedFilter(alert) {
      return alertIsArchived(alert);
    },
    generateChannelsList({ withSMS, withEmail, withPush, withWebhook }) {
      const channels = ['Platform'];
      if (withSMS) {
        channels.push(AlertsChannels.Sms);
      }
      if (withEmail) {
        channels.push(AlertsChannels.Email);
      }
      if (withPush) {
        channels.push(AlertsChannels.Push);
      }
      if (withWebhook) {
        channels.push(AlertsChannels.Webhook);
      }
      return channels.join(', ');
    },
    getPercent(alert) {
      return alert.status === 'archived' ? 0 : +alert.percentageToCompletion;
    },
  },
  created() {
    this.getAlertsGroupedByTickers().finally(() => {
      this.showSpinner = false;
    });
    if (!this.leaderTicker) {
      this.getLeaderTicker();
    }
  },
};
</script>


<style lang="scss" scoped>
  $row-height: 61px;
  $hover-menu-zindex: 3;
  .hover {
    display: none;
    background: $red-color3;
    width: 100%;
    height: $row-height;
    z-index: $hover-menu-zindex;
    position: absolute;
    left: 0;
    pointer-events: none;
  }
  .unexpected-click-preventer {
    display: none;
    position: absolute;
    width: 100%;
    content: '';
    left: 0;
    height: $row-height;
    transition: height 0s ease .3s;
    z-index: -10;
  }
  .hover-link {
    font-size: 12px;
    font-weight: 600;
    color: $white-color2;
    display: none;
    position: absolute;
    z-index: $hover-menu-zindex + 1;
    transform: translateY(-100%);
    cursor: pointer;
  }
  .table {
    position: relative;
  }
  .container {
    @include container;
    max-width: 1160px;
  }
  .circle-bar {
    &#{&} {
      position: absolute;
      left: 11px;
    }
  }
  .options {
    display: inline-block;
  }
  .head-title {
    display: inline-block;
    margin-right: 26px;
    margin-left: $alerts-list-padding-left;
  }
  .alerts-wrapper {
    border-radius: 5px;
    margin-top: 24px;
  }
  .icon {
    width: 24px;
    height: 24px;
    margin-right: 1px;
    position: relative;
  }
  .alert {
    &__icon {
      display: inline-block;
      margin-right: 14px;
    }
    &__name {
      @include font(17px, $black-color1, 500);
      display: inline-block;
    }
    &__switcher {
      display: inline-block;
      margin-right: 30px;
    }
    &__title {
      position: relative;
      width: calc(100% - 30px);
      display: inline-block;
    }
  }
  .icon-switcher,
  .icon-gear {
    cursor: pointer;
    position: relative;
  }
  .alert-top {
    display: flex;
    align-items: center;
    &__create-alert {
      position: absolute;
      right: 20px;
      top: 5px;
    }
  }
  $alert-top-link-box-shadow: 0px 0px 30px $black-color6;
  .alert-top-link {
    padding: 12px 18px;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    color: $black-color1;
    border-radius: 33px;
    margin-left: 12px;
    transition: $transition box-shadow;
    &:hover {
      box-shadow: $alert-top-link-box-shadow;
    }
  }
  .table {
    width: 100%;
    text-align: left;
    margin-top: 10px;
    padding: 0 30px;
    border-collapse: collapse;
    max-width: 100%;
    &__tr {
      border-bottom: 1px solid $grey-color3;
      &_archived {
        td {
          color: $grey-color2 !important;
        }
      }
      &_just-created {
        td {
          transition-duration: $transition;
        }
        &:hover {
          td {
            color: $red-color3;
          }
        }
        .table__td_label-new {
          opacity: 1;
          z-index: $hover-menu-zindex;
        }
      }
      &_hide-new-label {
        .table__td_label-new {
          opacity: 0;
        }
      }
    }
    &__th {
      @include font(11px, $grey-color2, 600);
      line-height: 17px;
      text-transform: uppercase;
      padding: 1px 10px 10px;
    }
    &__td {
      padding: 17px 10px;
      height: $row-height;
      @include font(12px, $black-color1, 500);
    }
    &__td,
    &__th {
      border-bottom: 1px solid $grey-color3 !important;
      &_parameter {
        padding-left: 30px;
        width: 134px;
        position: relative;
      }
      &_value {
        padding-left: 11px;
        width: 131px;
      }
      &_start {
        padding-left: 13px;
        width: 129px;
      }
      &_live {
        width: 162px;
        padding-left: 34px;
        position: relative;
      }
      &_repeat {
        width: 86px;
        padding-left: 5px;
      }
      &_channels {
        width: 169px;
        padding-left: 14px;
      }
      &_created {
        width: 115px;
        padding-left: 12px;
      }
      &_status {
        width: 100px;
        padding-left: 19px;
        &::first-letter {
          text-transform: uppercase;
        }
      }
      &_options {
        padding-left: 0;
        text-align: right;
        padding-right: 30px;
      }
    }
    &__td_live {
      border-bottom: none !important;
    }
    &__td_label-new {
      background: $red-color3;
      border-radius: 3px;
      position: absolute;
      left: -4px;
      padding: 1px 3px;
      top: 50%;
      margin-top: -6px;
      transition: left $transition/3, opacity $transition;
      opacity: 0;
      @include font(8px, $white-color2, 600);
    }
  }
  .td-inline-flex-wrapper {
    display: inline-flex;
    padding-left: 0;
    width: 100%;
    align-items: center;
    margin-top: 2px;
  }
  .show-alerts-wrapper {
    height: 71px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .show-alerts {
    @include removeBtnDefaults();
    @include font(12px, $red-color3, 600);
    display: block;
    text-transform: uppercase;
    text-align: center;
  }
  .icon-tendency {
    margin-left: 6px;
    margin-bottom: 1px;
  }
  .create-alert-btn {
    padding: 10px 10px 11px !important;
    position: relative;
    top: -4px;
    &_top {
      background: transparent;
    }
  }

  .view-all-currencies-wrapper {
    display: block;
    border-radius: 6px;
    text-align: center;
    padding: 18px 0;
  }
  .view-all-currencies {
    text-decoration: none;
    user-select: none;
    outline: none;
    @include font(12px, $red-color3 !important, 600);
  }
  .button-menu_disabled {
    pointer-events: none;
    svg {
      animation-duration: $transition * 5;
      animation-name: infinityRotate;
      animation-iteration-count: infinite;
      animation-direction: normal;
      animation-timing-function: linear;
    }
  }

  .spinner {
    margin: auto;
    position: relative;
    top: -120px;
  }

  .spinner-container {
    justify-content: center;
  }

.accordion-enter-to, .accordion-leave-to {
  .table__td_label-new {
    left: 0;
  }
}

.list-leave-active {
  .circle-bar,
  .icon-tendency {
    display: none;
  }
}
.create-alert-link {
  &_disabled {
    pointer-events: none;
  }
}
@media only screen and (max-width : 1130px) {
  .unexpected-click-preventer {
    display: flex;
  }
  .table__th,
  .table__td, {
    &_options {
      display: none;
    }
    &_channels {
      width: auto;
    }
    &__live {
      width: 174px;
    }
  }
  .table__trd:hover {
    .unexpected-click-preventer {
      height: 0;
      z-index: $hover-menu-zindex + 1;
    }
    .table__td_parameter {
      position: static;
    }
    .hover,
    .hover-link {
      display: flex;
    }
  }
}

.alert__create-btn_mobile {
  display: none;
}

@media only screen and (max-width : 1061px) {
  .table__td_label-new {
    left: 0;
  }
  .content-wrapper {
    overflow-x: auto;
  }
  .table {
    &#{&} {
      min-width: 994px;
      position: static !important;
    }
    /* Implement blur edges */
    &__trh,
    &__tr {
      &:before,
      &:after {
        content: '';
        position: absolute;
        width: 20px;
        background-color: $white-color2;
        filter: blur(4px);
        z-index: 2;
      }
      &:after {
        right: -6px;
      }
      &:before {
        z-index: 3;
        margin-left: -11px;
      }
    }
    &__tr {
      &:after,
      &:before {
        height: $row-height - 7;
      }
    }
    &__trh {
      &:after,
      &:before {
        $header-row-height: 28px;
        height: $header-row-height - 8;
      }
    }
    /* /Implement blur edges */
  }
  .list-leave-active {
    @include incrSelectorWeight(2) {
      .circle-bar,
      .icon-tendency {
        display: inline-block;
      }
      .hover-link,
      .hover {
        display: none;
      }
    }
  }
}

@media only screen and (max-width : 1024px) {
  .alert-top-link {
    box-shadow: $alert-top-link-box-shadow;
  }
  .alert__name {
    @include trimOverflowText(250px);
  }
  .view-all-currencies {
    width: 100%;
    display: block;
    $height: 51px;
    height: $height;
    line-height: $height;
  }
  .view-all-currencies-wrapper {
    padding: 0;
    border: 1px solid $grey-color12;
  }
  .show-alerts {
    width: 100%;
    height: 71px;
    margin: 0;
  }
}

@media only screen and (max-width : 586px) {
  .alert__create-btn_desktop {
    display: none;
  }
  .alert__create-btn_mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #E6E6E6;
    padding: 37px 0;
    .btn {
      padding-left: 26px;
      padding-right: 26px;
    }
  }
  .show-alerts {
    height: 59px;
  }
}

@media only screen and (max-width : 414px) {
  .alert__name {
    @include trimOverflowText(140px);
  }
}

/* Custom, iPhone Retina */
@media only screen and (max-width : 350px) {
}
</style>



// WEBPACK FOOTER //
// src/components/common/alertsList/index.vue